import {useEffect, useState} from "react";
import {Box, Button, Grid, TextField, Typography} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import * as React from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogActions from "@material-ui/core/DialogActions";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {CashGroupService} from "../CashGroups/CashGroupService";
import {CashUsersService} from "./CashUsersService";

const CashUserChangeUsername = ({openDialog, handleClose, needRefresh, selectedItemId}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new CashUsersService(fundID, token, snackbar, loading)

    const [newUsername, setNewUsername] = useState("");


    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    useEffect(() => {
        if (!openDialog) {
            clearFieldsData()
        }

    }, [openDialog])

    function doChange() {
        if (checkFieldsConditions()) {
            service.updateUsername(
                fundID,
                selectedItemId,
                newUsername,
            )
        }

    }

    function checkFieldsConditions() {
        if (newUsername.trim().length < 8 || newUsername.trim().length > 72) {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "نام کاربری باید بین 8 تا 72 کاراکتر باشد!"))
            return false
        }
        return true
    }

    function clearFieldsData() {
        setNewUsername("")
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                id="PersonalizedDialog">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                تغییر نام کاربری
            </DialogTitle>
            <section style={{padding: "1rem"}}>
                <Box className="d-flex flex-column">
                    <Grid xs={12} className="w-100 my-2">
                        <TextField
                            className="w-100"
                            id="outlined-disabled"
                            label="نام کاربری"
                            variant="outlined"
                            value={newUsername}
                            onChange={e => {

                                setNewUsername(e.target.value)
                            }}
                        />
                    </Grid>
                    <Button onClick={doChange} color="primary">
                        تغییر نام کاربری
                    </Button>
                </Box>
            </section>
        </Dialog>

    )

};

export default CashUserChangeUsername